import React from 'react';
import { CheckCircle2, Wallet } from 'lucide-react';

/**
 * Step 3 — Budget bracket selection (options depend on chosen path).
 */
export function BudgetStep({ form, setForm, budgetOptions }) {
  return (
    <div className="space-y-4" data-testid="step-budget">
      <div>
        <div className="flex items-center gap-2 text-[var(--gp-gold)]">
          <Wallet className="w-4 h-4" />
          <span className="text-[10px] tracking-[0.3em] uppercase font-medium">Step 3 / 4</span>
        </div>
        <h3 className="font-serif text-2xl text-[hsl(var(--primary))] mt-1">Qual è il tuo budget?</h3>
        <p className="text-sm text-muted-foreground mt-1">
          Anticipo per l&apos;acquisto dell&apos;appartamento a partire da €15.500 (o secondo piano rateale del resort scelto).
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
        {budgetOptions.map((b) => {
          const sel = form.budget_bracket === b.id;
          return (
            <button
              key={b.id}
              type="button"
              onClick={() => setForm((f) => ({ ...f, budget_bracket: b.id }))}
              className={`p-3.5 rounded-xl border-2 text-left transition-all ${
                sel
                  ? 'border-[var(--gp-gold)] bg-[var(--gp-gold)]/10 shadow-md'
                  : 'border-border bg-[var(--surface-2)] hover:border-[var(--gp-gold)]/50'
              }`}
              data-testid={`qf-budget-${b.id}`}
            >
              <div className="font-medium text-sm text-[hsl(var(--primary))]">{b.label}</div>
              {sel && <CheckCircle2 className="w-4 h-4 text-[var(--gp-gold)] mt-1.5" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}
